import { Box, MenuItem } from '@monorepo/nova-ui';
import {
  ProfileMenuOption,
  ProfileMenuOptionValue,
} from './profile-menu.types';
import {
  StyledDesktopProfileMenu,
  StyledMenuItemIcon,
  StyledMenuItemThemeSwitch,
  StyledProfileMenuDivider,
} from './styled/profile-menu.styled';

interface Props {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  options: ProfileMenuOption[];
}

export const ProfileMenuDropdown = ({
  anchorEl,
  open,
  onClose,
  options,
}: Props) => {
  const visibleOptions = options.filter((option) => !option.hidden);
  const logoutIndex = visibleOptions.findIndex(
    (option) => option.value === ProfileMenuOptionValue.Logout,
  );

  const handleMenuItemClick = (option: ProfileMenuOption) => {
    option.onClick?.();
    onClose();
  };

  return (
    <StyledDesktopProfileMenu
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      disableScrollLock
    >
      {visibleOptions.map((option, index) => (
        <div key={option.value}>
          {index === logoutIndex && logoutIndex > 0 && (
            <StyledProfileMenuDivider />
          )}
          <MenuItem onClick={() => handleMenuItemClick(option)}>
            {option.leftComponent && (
              <StyledMenuItemThemeSwitch>
                {option.leftComponent}
              </StyledMenuItemThemeSwitch>
            )}
            {option.icon && (
              <StyledMenuItemIcon>{option.icon}</StyledMenuItemIcon>
            )}
            <Box flex={1}>{option.label}</Box>
          </MenuItem>
        </div>
      ))}
    </StyledDesktopProfileMenu>
  );
};
